import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-dark text-center text-white py-3">
      &copy; {new Date().getFullYear()} BlogFortis. All Rights Reserved.
    </footer>
  );
};

export default Footer;
